import { render, staticRenderFns } from "./VAppLayout.vue?vue&type=template&id=c84443dc&scoped=true&"
import script from "./VAppLayout.vue?vue&type=script&lang=js&"
export * from "./VAppLayout.vue?vue&type=script&lang=js&"
import style0 from "./VAppLayout.vue?vue&type=style&index=0&id=c84443dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84443dc",
  null
  
)

export default component.exports